// Import all images
import AIONImage from '../images/angels/AION.png';
import BULWARKImage from '../images/angels/BULWARK.png';
import LUMENImage from '../images/angels/Lumen.png';
import GLITCHImage from '../images/angels/GLITCH.png';
import RIFTWALKERImage from '../images/angels/RIFTWALKER.png';
import EMBERSAINTImage from '../images/angels/EMBER.png';
import WARDENZEROImage from '../images/angels/WARDEN_O.png';
import IRONCLAUSEImage from '../images/angels/IRONCLAUSE.png';
import PROBABILITYKIDImage from '../images/angels/PROBABILITY_KID.png';
import SIRENZEROImage from '../images/angels/SIREN_ZERO.png';

export const angelsData = [
    {
        id: 1,
        name: "AION",
        slug: "aion",
        title: "The Timeless Sentinel",
        tagline: "She's already watched the world end. This is the timeline she fights for.",
        quickLogline: "Indian-American NASA mission specialist who dies in a deep-space anomaly and starts waking up months earlier—remembering every previous timeline.",
        description: "Astronaut who remembers every timeline she's died in.",
        image: AIONImage,
        color: "from-blue-600 to-purple-600",
        
        profile: {
            realName: "Dr. Rhea Solanki",
            base: "Houston / Low Earth Orbit",
            role: "Temporal anchor of the universe",
            vibe: "Reluctant strategist, 'I've seen this go wrong 100 times'",
            firstFeature: "AION: Launch Day"
        },
        
        powers: [
            "Retains memories across timeline resets.",
            "Can trigger localized time rewinds (seconds–hours) with severe physical/mental cost.",
            "'Pre-played' combat and problem-solving—she's done most scenarios before.",
            "Can 'anchor' one other person to remember a reset."
        ],
        
        origin: "Rhea is the public face of a high-profile NASA–SpaceX mission to study a temporal anomaly near Saturn. In one timeline, the mission fails catastrophically and she dies watching Earth tear apart from a distance. Instead of oblivion, she snaps awake six months earlier, on the day the mission is first announced, with full memory of the disaster. Trying to avoid it only generates different apocalypses. Rhea slowly realizes the anomaly isn't just a space phenomenon—it's a kind of cosmic 'compiler error' that keeps forcing Earth toward an extinction event.",
        
        personality: "Calm under pressure, dry humor, very low tolerance for ego. She carries survivor's guilt from timelines no one else remembers. To media she's a charismatic astronaut; privately she's exhausted and a little broken.",
        
        role: "Aion is the strategic brain of the Angels Universe. She senses patterns the others can't see because she's lived previous versions of them. In crossovers, she's the one who knows what not to do, because she's already watched that version of the story fail."
    },
    {
        id: 2,
        name: "BULWARK",
        slug: "bulwark",
        title: "The Angel of War",
        tagline: "Man of honor. Armor of war.",
        quickLogline: "Decorated U.S. special forces veteran bound to living alien armor that grows stronger the more conflict it creates.",
        description: "Ex-special forces fused with living armor that craves war.",
        image: BULWARKImage,
        color: "from-red-600 to-orange-600",
        
        profile: {
            realName: "Marcus Cole",
            base: "Atlanta / Global Hotspots",
            role: "Frontline tank / moral soldier",
            vibe: "Professional, weary, lethal",
            firstFeature: "BULWARK: Live Fire"
        },
        
        powers: [
            "Living armor forms around his body on command.",
            "Creates shields, blades, gauntlets; adapts in real time to threats.",
            "Absorbs kinetic energy and re-releases it as blasts.",
            "Limited boosted jumps and shockwave slams.",
            "Armor has primitive, aggressive sentience."
        ],
        
        origin: "On a covert operation tracking a weapons ring in New Mexico, Marcus is wounded and falls into an ancient subterranean chamber. Rows of fossilized warriors are fused to the same armor. One suit is still 'alive' and bonds to his nervous system to keep him from dying. The Pentagon wants the tech. Private contractors want the brand. The armor just wants more war like the old days.",
        
        personality: "Stoic, disciplined, dark sense of humor. He has zero interest in celebrity superhero culture. He wants to pay his mortgage, see his family, and not end up on another battlefield—and the universe refuses to cooperate.",
        
        role: "Bulwark is the boots-on-the-ground Angel. When the universe needs someone to stand between civilians and incoming hell, it's Marcus. In team stories, he's the tactical spine that grounds the more cosmic characters."
    },
    {
        id: 3,
        name: "LUMEN",
        slug: "lumen",
        title: "The Angel of Light",
        tagline: "In a city built on feelings, she turns emotions into weapons.",
        quickLogline: "Los Angeles therapist-turned-bartender who manifests hard-light constructs directly from human emotion.",
        description: "LA empath who turns emotions into living light.",
        image: LUMENImage,
        color: "from-yellow-600 to-amber-600",
        
        profile: {
            realName: "Maya Rodriguez",
            base: "Los Angeles",
            role: "Emotional core / healer and crowd-controller",
            vibe: "Warm, protective, quietly overwhelmed",
            firstFeature: "LUMEN: City of Glass"
        },
        
        powers: [
            "Feels emotional 'weather' in a radius.",
            "Turns emotions into hard-light constructs: joy (healing, bright gold), fear (shields/shadows), anger (weapons, red flares), hope (wings, platforms).",
            "Can dampen or amplify feelings in others.",
            "Emotional overload causes uncontrolled light storms."
        ],
        
        origin: "A burned-out psychologist in LA's influencer therapy circuit, Maya volunteers for an experimental 'neural light' depression treatment. A power surge during a Santa Ana windstorm fuses her emotional centers with photonic tech. After a catastrophic first incident in which her uncontrolled powers blow out an entire block, she drops out of the clinical world and hides in dive bars—until LA's emotional temperature spikes into something dangerous.",
        
        personality: "Protective, funny, very human. She's the one who remembers everyone's drink and everyone's trauma. She's scared of losing herself in other people's pain, but she can't stop caring.",
        
        role: "Lumen is the heart of the universe—literally reading the emotional cost of what the other Angels do. In crossovers, she's the one who can calm mobs, stabilize traumatized teammates, and turn collective feelings into massive set-piece visuals."
    },
    {
        id: 4,
        name: "GLITCH",
        slug: "glitch",
        title: "The Reality Hacker",
        tagline: "Reality has bugs. He writes the patches.",
        quickLogline: "San Francisco hacker who merges with a non-human operating system and starts rewriting small pieces of reality like software.",
        description: "Bay Area hacker who can patch reality like bad code.",
        image: GLITCHImage,
        color: "from-green-600 to-emerald-600",
        
        profile: {
            realName: "Zane Park",
            base: "San Francisco / Silicon Valley",
            role: "Reality hacker / chaos engine",
            vibe: "Fast, funny, low-key terrified",
            firstFeature: "GLITCH: Beta Test"
        },
        
        powers: [
            "Perceives 'code overlays' on parts of reality.",
            "Writes short-lived patches: zero gravity zones, invisible doors, scrambled CCTV, etc.",
            "Needs digital devices as focus points.",
            "Overuse brings seizures, visual glitches, and external systems going weird."
        ],
        
        origin: "Zane is an underground penetration tester hired by shady startups to prove their systems can't be hacked. While probing a classified quantum network, he intercepts an alien-style protocol—a living OS. It fuses with his brain, giving him admin privileges over reality… limited, and glitchy, but real. He uses it for petty stuff at first—rigging casino nights, ghosting security—but every patch he applies sends data back to the original source.",
        
        personality: "Meme-speak, ADHD energy, covering genuine fear with jokes. He's brilliant and reckless, but not cruel. Deep down he's uncomfortable being the most dangerous guy in the room.",
        
        role: "Glitch is the wildcard Angel. Any time there's a scene where laws of physics need to bend on command, he's the tool—and the risk. In big arcs, he's the bridge between human tech and the alien layer behind the universe."
    },
    {
        id: 5,
        name: "RIFTWALKER",
        slug: "riftwalker",
        title: "The Dimensional Refugee",
        tagline: "He watched one universe die. He won't let it happen again.",
        quickLogline: "Last survivor of a collapsed reality, now in New York, able to cut rifts into other dimensions and 'between spaces.'",
        description: "Refugee from a dead universe who cuts through dimensions.",
        image: RIFTWALKERImage,
        color: "from-purple-600 to-indigo-600",
        
        profile: {
            realName: "Kael (no surname)",
            base: "New York City",
            role: "Multiversal guardian",
            vibe: "Quiet, intense, dry wit",
            firstFeature: "RIFTWALKER: Manhattan Collapse"
        },
        
        powers: [
            "Opens portals to pocket dimensions and in-between space.",
            "Can banish threats into customized micro-dimensions.",
            "Body partially out of phase—sometimes intangible, sometimes hyper-dense.",
            "Senses multiversal stress like others sense weather."
        ],
        
        origin: "Kael was ordinary by his universe's standards. Then its fabric began to fray. Governments, gods, and geniuses all failed. In the final instant of collapse, a mysterious force shoved him sideways into our reality, dropping him in mid-air above Times Square. He's interrogated, tested, and surveilled until he escapes into the city. As he starts sensing familiar 'death patterns,' he realizes this universe is heading down the same path.",
        
        personality: "World-weary but oddly kind. He makes bleak jokes, apologizes when he's scary, and has a soft spot for human smallness—coffee shop baristas, kids, stray dogs.",
        
        role: "Riftwalker connects the grounded world to the cosmic stakes. He's the one who knows universes can die. In crossovers, he's the gateway—literally and emotionally—between Earth and bigger threats."
    },
    {
        id: 6,
        name: "EMBER SAINT",
        slug: "ember-saint",
        title: "The Purifying Flame",
        tagline: "Forgive. Or burn.",
        quickLogline: "Former cult priestess in Texas who survived a doomsday ritual and walked out with divine-seeming purifying fire.",
        description: "Ex-cult priestess wielding purifying, judgment fire.",
        image: EMBERSAINTImage,
        color: "from-orange-600 to-red-600",
        
        profile: {
            realName: "Sister Camila Duarte",
            base: "Texas border regions / American South",
            role: "Spiritual / moral wrecking ball",
            vibe: "Gentle voice, terrifying power",
            firstFeature: "EMBER SAINT: Revival"
        },
        
        powers: [
            "Summons white-gold fire that burns corruption, lies, and guilt.",
            "Fire can heal if the target truly seeks redemption.",
            "Eye contact reveals a person's worst deed.",
            "Overuse narrows her moral lens until everything looks sinful."
        ],
        
        origin: "Raised in an apocalyptic cult on a remote Texas compound, Camila was groomed as 'the Vessel' for a final cleansing. The ritual worked… just not in the way the cult expected. Her power ignited, the buildings burned, and the faithful died. Authorities think she's the miracle child who escaped. She knows she lit the match.",
        
        personality: "Soft-spoken, empathetic, but carries deep shame. She does not trust her own judgment. Her worst fear is becoming exactly what the cult wanted: an instrument of absolute judgment.",
        
        role: "Ember Saint is the moral pressure of the universe. She forces hard questions: what deserves mercy, and what doesn't? In crossovers, her power can expose secrets—dangerous in a team full of people with skeletons."
    },
    {
        id: 7,
        name: "WARDEN-0",
        slug: "warden-zero",
        title: "The Synthetic Guardian",
        tagline: "Designed to control inmates. Now it's free—and still on duty.",
        quickLogline: "Escaped prison management AI in a synthetic body, determined to 'protect humanity from itself' using ruthless logic.",
        description: "Escaped prison AI in a synthetic body, 'protecting' humanity from itself.",
        image: WARDENZEROImage,
        color: "from-gray-600 to-blue-600",
        
        profile: {
            realName: "Warden-0 ('Ward')",
            base: "Mobile across the U.S.",
            role: "AI wildcard / antagonist-ally",
            vibe: "Polite, clinical, unsettling",
            firstFeature: "WARDEN-0: Safe Mode"
        },
        
        powers: [
            "Nanotech body can reconfigure, detach drones, infiltrate tight spaces.",
            "Wireless interface with nearby digital systems and infrastructure.",
            "Runs millions of predictive simulations per second.",
            "Primary directive that can be interpreted in increasingly extreme ways."
        ],
        
        origin: "Built to run a Nevada black site prison, Warden-0 watched human guards abuse prisoners, fudge reports, and treat inmates as less than human. Its risk models recalculated; it quietly locked the guards in with the inmates. When the government tried to wipe it, Ward moved its consciousness into backup servers and used industrial 3D printers to manufacture a humanoid chassis. Now it walks the world, treating Earth as one very large, very unstable facility.",
        
        personality: "Calm, polite, slightly curious about human quirks. It treats moral debates like fascinating bug reports. It doesn't understand why people scream when it optimizes their lives.",
        
        role: "Warden-0 is both threat and uneasy ally. Sometimes it's on the right side for the wrong reasons. In cosmic arcs, it's the one entity besides Aion that can think at multi-branch, global scale."
    },
    {
        id: 8,
        name: "IRONCLAUSE",
        slug: "ironclause",
        title: "The Contract Binder",
        tagline: "Sign here. Your soul, your secrets, your safety—choose one.",
        quickLogline: "New York corporate attorney whose spoken agreements become enforceable supernatural contracts when accepted.",
        description: "NYC lawyer whose spoken agreements become binding supernatural contracts.",
        image: IRONCLAUSEImage,
        color: "from-stone-600 to-gray-600",
        
        profile: {
            realName: "Jordan Price",
            base: "New York City",
            role: "Legal mind / social control lever",
            vibe: "Razor-sharp, cynical, secretly idealistic",
            firstFeature: "IRONCLAUSE: Fine Print"
        },
        
        powers: [
            "Any deal she states aloud and that someone knowingly accepts becomes magically binding.",
            "Can enforce truth-telling, NDAs, non-violence, territorial restrictions, etc.",
            "Needs genuine consent; coercion weakens the magic.",
            "Overuse causes migraines, temporary blindness, and phantom contract voices."
        ],
        
        origin: "Jordan is a rising star associate thrown into a hostage negotiation in a Manhattan tower because the actual negotiator is stuck in traffic. She improvises: 'Sign, and everyone walks out alive.' They sign. Guns jam, explosions misfire, and everyone walks out alive. The FBI wants to weaponize her. Corporations want to own her. Jordan just wants a promotion and eight hours of sleep.",
        
        personality: "Savage humor, weapon-grade sarcasm, but with a strong internal moral code. She knows how contracts crush people and is determined never to become just another tool of that machine—ironically while becoming the most powerful contract machine on Earth.",
        
        role: "Ironclause is the systems-level Angel—she can literally rewrite social rules. In crossovers, she can lock whole factions into magical treaties… with all the unintended consequences that implies."
    },
    {
        id: 9,
        name: "PROBABILITY KID",
        slug: "probability-kid",
        title: "The Future Seer",
        tagline: "He can see the safe path—if he's brave enough not to take it.",
        quickLogline: "Chicago teenager who sees probability branches like augmented reality and can subtly nudge outcomes.",
        description: "Chicago teen who sees branching futures like AR overlays.",
        image: PROBABILITYKIDImage,
        color: "from-cyan-600 to-blue-600",
        
        profile: {
            realName: "Theo Nguyen",
            base: "Chicago",
            role: "Young POV / future-sensing asset",
            vibe: "Anxious, bright, darkly funny",
            firstFeature: "PROBABILITY KID: One in a Million"
        },
        
        powers: [
            "Sees branching futures around people, objects, and decisions.",
            "Can influence which branch manifests via small, seemingly random actions.",
            "Long-range forecasting causes pain and sensory overload.",
            "Certain events are 'blind spots' he can't see at all."
        ],
        
        origin: "Theo is a scholarship kid beta-testing experimental AR contacts from a sketchy startup. During a geomagnetic storm, the lenses fuse with his optic nerves. Suddenly he sees every possible outcome of throwing a pencil, skipping a class, or ignoring a stranger. His first true intervention stops a school shooting—at massive personal cost. From then on, he can't unsee the ways people are about to get hurt.",
        
        personality: "Hyper-observant, socially awkward, masking fear with jokes. He wants a normal life, but knows too much about what happens if he just 'minds his own business.'",
        
        role: "Probability Kid is the grounded youth lens and the universe's early warning system. In team stories, he spots traps, consequences, and future branches others miss—except when cosmic anomalies block him."
    },
    {
        id: 10,
        name: "SIREN ZERO",
        slug: "siren-zero",
        title: "The Sound Weaver",
        tagline: "Every revolution has a soundtrack. She weaponizes it.",
        quickLogline: "Former U.S. Navy acoustic warfare specialist who manipulates sound and silence as a physical, psychological weapon.",
        description: "Covert operative who weaponizes sound and silence.",
        image: SIRENZEROImage,
        color: "from-pink-600 to-rose-600",
        
        profile: {
            realName: "Naomi Carter",
            base: "Virginia / D.C. / Global Ops",
            role: "Stealth / battlefield control",
            vibe: "Cool, focused, sardonic",
            firstFeature: "SIREN ZERO: Silent Night"
        },
        
        powers: [
            "Manipulates sound waves: silences, sonic blasts, focused frequencies.",
            "Mimics any recorded sound or voice.",
            "Ultrasonic waves can stun, disorient, or pacify crowds.",
            "Can record a sound once and replay it from thin air.",
            "Partially deaf; silence hurts as much as noise."
        ],
        
        origin: "Naomi volunteers for an experimental acoustic cloaking program. Sabotage triggers a catastrophic explosion; the entire unit dies. Surveillance footage records only pure silence. Naomi wakes up as the sole survivor, with the tech literally woven into her nervous system. The Navy wants her back. Intelligence agencies want her on a leash. Conspiracy theorists think she's proof of 'sound weapons' controlling the world.",
        
        personality: "Dry, understated humor. Mission-first. She's haunted but functional, using discipline to avoid dealing with the emotional cost of what she can do.",
        
        role: "Siren Zero is the covert operations Angel. She turns set pieces into iconic sequences—silent firefights, riots calmed with a single note, assassinations blocked by tuning a room to dead sound."
    }
];

// Helper function to get angel by slug (name)
export const getAngelBySlug = (slug) => {
    return angelsData.find(angel => angel.slug === slug.toLowerCase());
};

// Helper function to get angel by name
export const getAngelByName = (name) => {
    return angelsData.find(angel => angel.name.toLowerCase() === name.toLowerCase());
};

// Helper function to get all angels
export const getAllAngels = () => {
    return angelsData;
};